import { IStageApi } from '../types';
import Core from '@mediaplatform/sportal365-football-sdk-v2';

export default (sdk: Core): IStageApi => {
  const getStage: IStageApi['getStage'] = ({ signal, dataGroups, stageId, competitionId, seasonId, stageType, dataLimit, dataOffset }) => {
    if (stageId || competitionId || seasonId) {
      const stage = sdk.stage({
        stageId: stageId?.toString(),
        seasonId: seasonId?.toString(),
        competitionId: competitionId?.toString(),
        limit: dataLimit || '',
        offset: dataOffset || 0,
      });

      if (!stage) return;

      if (stageType) {
        stage.withStageType(stageType);
      }

      if (dataGroups && Array.isArray(dataGroups) && dataGroups.length > 0) {
        stage.withGroups(dataGroups);
      }

      return stage.withStandingConfig('RULES_FORM_EVENTS').withRules().get({ signal });
    }
    console.warn('No stage/season/competition id provided');
  };
  return { getStage };
};
